import { TypeItemTab } from '../../../lib/types/item-tab'
import { VerticalTabContentItem } from './types'
import { TypeComponentVerticalTabContent } from '../../../lib/types/component-vertical-tab-content'
import { ColorStyleType } from '@lib/types/section-vertical-tabs'

import styles from './accent-styles.module.scss'

export const getVerticalTabContentItem = (entry: TypeItemTab): VerticalTabContentItem => {
  const { title, description, link, image } = entry.fields.content.fields as TypeComponentVerticalTabContent['fields']
  return {
    title: entry.fields.label,
    content: {
      title,
      description,
      link,
      image,
    },
  }
}

export const getColorStyleClassName = (colorStyle?: ColorStyleType) => {
  switch (colorStyle) {
    case ColorStyleType.Black:
      return styles.blackAccentStyle
    default:
    case ColorStyleType.Default:
      return null
  }
}
